import { render, staticRenderFns } from "./Drwot.vue?vue&type=template&id=0b67ae2e"
import script from "./Drwot.vue?vue&type=script&lang=js"
export * from "./Drwot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b67ae2e')) {
      api.createRecord('0b67ae2e', component.options)
    } else {
      api.reload('0b67ae2e', component.options)
    }
    module.hot.accept("./Drwot.vue?vue&type=template&id=0b67ae2e", function () {
      api.rerender('0b67ae2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/template/Drwot.vue"
export default component.exports